import React from 'react'
import "./CustomContent.css"
import LeftBar from '../leftbar/LeftBar'

export default function CustomContent({ content }) {
  return (

    <>
      <div className="custom-content">
        <div className="row">
          <div className="col-md-9">
            <div class="left">
              <h2>{content?.title}</h2>
              <div className="time">
                <span><strong>Tarih:</strong> {new Date(content?.atCreatedDate).toLocaleDateString("tr-TR")}</span>
              </div>


              {(() => {
                if (content?.coverImageUrl) {
                  return (
                    <div className='picture'>
                      <img src={"https://content.samsun.edu.tr/" + content?.coverImageUrl} />
                    </div>
                  )
                }
              })()}

              <div className="post" dangerouslySetInnerHTML={{ __html: content?.details }} />
            </div>
          </div>
          <div class="col-md-3">
            <LeftBar />
          </div>
        </div>
      </div>
    </>
  )
}
